import { useEffect, useState } from 'react';
import { Capacitor } from '@capacitor/core';

export default function InstallApp() {
  const [release, setRelease] = useState(null);
  const [installPrompt, setInstallPrompt] = useState(null);
  const [offline, setOffline] = useState(!navigator.onLine);
  const native = Capacitor.isNativePlatform();
  useEffect(() => {
    if (native) return;
    const controller = new AbortController();
    fetch('/downloads/release.json', { cache: 'no-store', signal: controller.signal })
      .then(response => response.ok ? response.json() : null)
      .then(data => {
        const android = data?.android;
        if (android?.url?.startsWith('/downloads/') && android.url.endsWith('.apk') && android.sha256) setRelease(android);
      }).catch(() => {});
    const beforeInstall = event => { event.preventDefault(); setInstallPrompt(event); };
    const installed = () => setInstallPrompt(null);
    window.addEventListener('beforeinstallprompt', beforeInstall);
    window.addEventListener('appinstalled', installed);
    return () => {
      controller.abort();
      window.removeEventListener('beforeinstallprompt', beforeInstall);
      window.removeEventListener('appinstalled', installed);
    };
  }, [native]);
  useEffect(() => {
    const update = () => setOffline(!navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => { window.removeEventListener('online', update); window.removeEventListener('offline', update); };
  }, []);
  if (native) return null;
  return (
    <section id="app" aria-labelledby="install-title" className="px-4 sm:px-8 py-20 border-t border-slate-800 bg-[#090E17]">
      <div className="max-w-5xl mx-auto">
        <p className="text-cyan-400 font-mono text-xs uppercase tracking-[0.2em] mb-3">FM REAL con vos</p>
        <h2 id="install-title" className="font-heading font-bold text-3xl sm:text-4xl mb-4">Llevá la radio en tu celular</h2>
        <p className="text-slate-400 mb-8">Escuchá desde la app, sin salir de FM REAL. La transmisión necesita conexión a internet.</p>
        {offline && <p role="status" className="text-amber-300 mb-6">Estás sin conexión. Podés consultar la página, pero para escuchar la radio necesitás internet.</p>}
        <div className="grid md:grid-cols-2 gap-6">
          <div className="rounded-2xl border border-slate-700 p-6">
            <h3 className="font-heading text-xl font-bold mb-3">Android</h3>
            {release ? <>
              <a href={release.url} download className="inline-flex rounded-full bg-cyan-400 text-slate-950 px-6 py-3 font-bold" data-testid="download-apk">Descargar app Android</a>
              <p className="text-slate-400 text-sm mt-4">Versión {release.version} · {(release.bytes / 1048576).toFixed(1)} MB · Android 7 o superior, preparada para Android 16.</p>
              <p className="text-slate-400 text-sm mt-3">Abrí el archivo descargado y seguí las indicaciones de Android para instalarlo. Descargalo únicamente desde fmreal963.com. No desactives Play Protect.</p>
              <details className="text-xs text-slate-500 mt-4 break-all"><summary className="cursor-pointer">Verificar integridad (SHA-256)</summary><p className="mt-2 font-mono">{release.sha256}</p></details>
            </> : <p className="text-slate-400 text-sm">La descarga de la APK estará disponible cuando termine su preparación. Mientras tanto, escuchá desde esta web.</p>}
            {installPrompt && <button className="block text-cyan-400 underline mt-4" onClick={async () => {
              await installPrompt.prompt(); await installPrompt.userChoice; setInstallPrompt(null);
            }}>Instalar versión web</button>}
          </div>
          <div className="rounded-2xl border border-slate-700 p-6">
            <h3 className="font-heading text-xl font-bold mb-3">iPhone y iPad</h3>
            <p className="text-slate-300 text-sm mb-4">Instalá la versión web de FM REAL desde Safari. No necesitás descargar una APK ni pagar.</p>
            <ol className="list-decimal pl-5 space-y-2 text-slate-400 text-sm">
              <li>Abrí <a className="text-cyan-400 underline" href="https://fmreal963.com/#app" target="_blank" rel="noopener noreferrer">fmreal963.com</a> en Safari.</li>
              <li>Tocá Compartir y seleccioná Agregar a Inicio.</li>
              <li>Si aparece la opción, activá Abrir como app web y tocá Agregar.</li>
            </ol>
            <p className="text-slate-500 text-xs mt-4">Es una app web instalable, no una publicación en App Store. El audio en segundo plano depende de Safari y de iOS.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
